import { render, staticRenderFns } from "./swiperBg.vue?vue&type=template&id=c751af2e&scoped=true"
import script from "./swiperBg.vue?vue&type=script&lang=js"
export * from "./swiperBg.vue?vue&type=script&lang=js"
import style0 from "./swiperBg.vue?vue&type=style&index=0&id=c751af2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c751af2e",
  null
  
)

export default component.exports